import {makeStyles} from "@material-ui/core/styles";

export const useInfoBoxStyles = makeStyles(() => ({
    infoBoxName: {
        borderRadius: "0.5em",
        backgroundColor: props => props.shouldSwitch ? "#7C92A5" : "#fff",
        border: props => props.shouldSwitch ? "none" : "2px solid rgba(0,0,0,0.2)",
        padding: "8px 48px",
        display: "flex"
    },
    infoBox: {
        color: props => props.shouldSwitch ? "#fff" : "#000",
        alignItems: "center",
        marginLeft: "24px",
        display: "inline-flex",
        cursor: "pointer"
    },
    infoBoxTypography: {
        color: props => props.shouldSwitch ? "#fff" : "#000",
        maxWidth: "150px",
        display: "block",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
    }
}));
